import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/f774deb3335ef344be2f4793f6ebd557/4921c38636ad195fd01148c3e26c34c3.png" 
              alt="Logo" 
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/services') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              Services
            </Link>
            <Link
              to="/buy-tradelines"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/buy-tradelines') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              Buy Tradelines
            </Link>
            <Link
              to="/how-it-works"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/how-it-works') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              How It Works
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              About
            </Link>
            <Link
              to="/faq"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/faq') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/contact') 
                  ? 'text-navy' 
                  : isScrolled 
                    ? 'text-gray-700 hover:text-navy' 
                    : 'text-white hover:text-gray-200'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/apply"
              className="bg-navy text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-navy-light transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply Now
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
